<section class="container">
    <section>
        <header>
            <img class="logo" src="/assets/promo-now.svg">
        </header>
    </section>
    <section>
        <img class="diagram" src="/assets/404-diagram.svg">
    </section>
    <h1>Page not found!</h1>
</section>